import { Divider } from '@backoffice-frontend/patterns'
import { MinusIcon, PlusIcon } from '@moia-dev/pace-icons'
import { IconButton } from '@moia-dev/pace-web'
import { useContext } from 'react'
import { HereMapContext } from './HereMap'

/**
 * ZoomButtons is a button group with an zoom-in (+) and a zoom-out (-) button.
 * It should be used as a direct child of the `MapLegend` component.
 */
export const ZoomButtons = () => {
  const { zoomIn, zoomOut } = useContext(HereMapContext)

  return (
    <div
      css={theme => ({
        background: theme.semantic.ColorSurfaceDefault,
        borderRadius: 'var(--radius-medium)',
        outline: '1px solid var(--color-border-on-action-secondary-default)',
        boxShadow: 'var(--shadow-depth-1)',
      })}
    >
      <IconButton
        onClick={zoomIn}
        variant="plain"
        icon={
          <PlusIcon
            css={theme => ({ color: theme.semantic.ColorContentReduced })}
          />
        }
      />
      <Divider css={theme => ({ margin: theme.spacing(0, 1) })} />
      <IconButton
        onClick={zoomOut}
        variant="plain"
        icon={
          <MinusIcon
            css={theme => ({ color: theme.semantic.ColorContentReduced })}
          />
        }
      />
    </div>
  )
}
